// import axios from "axios";

export default {
  state: () => ({
    show: false,
  }),
  getters: {},
  mutations: {
    setShow(state, data) {
      state.show = data;
    },
  },
  actions: {
    toggleShow({ state, commit }) {
      commit("setShow", !state.show);
    },
  },
  namespaced: true,
};
